import { inject, Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { FiscalProfileBackend } from "src/app/backend/api/fiscal-profile.backend";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { UserService } from "src/app/services/user.service";

@Injectable()
export class ProvideFiscalProfilesGuard {
  private readonly fiscalProfileBackend = inject(FiscalProfileBackend);
  private readonly bootstrapService = inject(BootstrapService);
  private readonly userService = inject(UserService);

  async canActivate(): Promise<boolean> {
    try {
      if (this.userService.able("read", "fiscal-profile")) {
        const fiscalProfiles = await lastValueFrom(
          this.fiscalProfileBackend.listAll()
        );
        this.bootstrapService.setFiscalProfiles(fiscalProfiles);
      } else {
        this.bootstrapService.setFiscalProfiles([]);
      }
    } catch (ex) {
      this.bootstrapService.setFiscalProfiles([]);
    }

    return true;
  }
}
